module.exports = __webpack_public_path__ + "static/media/texture.2de5d7b6.jpg";